import * as React from 'react';
import { useIntlUds } from '../../translations/UdsIntlProvider';
import StatusChip, { StatusChipType } from './StatusChip';

interface ActiveInactiveStatusChipProps {
  active?: boolean;
}

export const ActiveInactiveStatusChip: React.FC<React.PropsWithChildren<ActiveInactiveStatusChipProps>> = ({
  active
}) => {
  const { intl } = useIntlUds();
  return (
    <StatusChip
      label={active ? intl.Chip.ActiveInactiveStatusChip.activeLabel : intl.Chip.ActiveInactiveStatusChip.inactiveLabel}
      type={active ? StatusChipType.LIGHT_BLUE : StatusChipType.GREY}
    />
  );
};
